import type { BuilderElement } from '@/utils/builder/types';
import { generateId } from '@/utils/builder/id-utils';

const createDefaultFormGroupInput = (
  name: string,
  placeholder: string
): BuilderElement => {
  return {
    id: generateId(),
    type: 'input',
    name,
    placeholder,
    styles: {
      width: '100%',
      padding: '12px',
      margin: '0',
      borderRadius: '4px',
      border: '1px solid tertiary',
      fontSize: '16px',
    },
    _isNew: true,
    _needsSync: true,
  };
};

export const createDefaultFormGroupElement = (): BuilderElement => {
  const id = generateId();

  return {
    id,
    type: 'form-group',
    styles: {
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
      width: '100%',
    },
    children: [
      createDefaultFormGroupInput('field1', 'Field 1'),
      createDefaultFormGroupInput('field2', 'Field 2'),
    ],
    _isNew: true,
    _needsSync: true,
  };
};

